import { forwardRef } from 'react';

import { Button, ButtonProps } from 'common/components';
import { AddIcon } from 'icons';
import { withPrivilegeDependency } from 'modules/authorization/hocs';

export const AddButton = forwardRef<HTMLButtonElement, ButtonProps>(({ children, ...props }, ref) => (
  <Button {...props} startIcon={<AddIcon />} ref={ref}>
    {children}
  </Button>
));

export const AddButtonWithPrivilege = withPrivilegeDependency(AddButton);
